const TYPE_GAME_MAT_BG = {
  OneToOne: 1,
  OneToMany: 2,
};

export { TYPE_GAME_MAT_BG };
